module.exports = __webpack_public_path__ + "static/media/part2.b3f8fd0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part2.jpg
// module id = 804
// module chunks = 1